import { createAction, props } from "@ngrx/store";
import { Agency } from "../../../core/models/agency";
import { State } from "../state";

export const clearAgencies = createAction("[Agencies Page] Clear Agencies");

export const setAgencies = createAction(
  "[Agencies Page] Set Agencies",
  props<{
    agencies: Agency[];
  }>()
);

export const setAgenciesFeatureState = createAction(
  "[Agencies Page] Set Feature State",
  props<{ state: State }>()
);
